




















































































































































import { SfButton } from '@storefront-ui/vue';
import NewsLetter from '~/components/JetUi/molecules/NewsLetter/NewsLetter.vue';
import SvgImage from './General/SvgImage.vue';

export default {
  name: 'Footer',
  components: {
    SvgImage,
    NewsLetter,
    SfButton,
  },
  data() {
    return {
      currentYear: new Date().getFullYear(),

      socialMedias: [
        { name: 'instagram', link: 'https://www.instagram.com/' },
        { name: 'linkedin', link: 'https://www.linkedin.com/' },
        { name: 'facebook', link: 'https://www.facebook.com/' },
      ],

    };
  },
  methods: {
    openSocialMedia(socialMedia: string) {
      switch (socialMedia) {
        case 'instagram':
          window.open('https://www.instagram.com/espacialsuprimentos/', '_blank');
        case 'facebook':
          window.open('https://www.facebook.com/EspacialSuprimentos', '_blank');
        case 'linkedin':
          window.open('https://www.linkedin.com/company/espacial-suprimentos-de-escritorio-e-informatica/', '_blank');
      }
    },
  },
};
